import useZWR from "@/utils/use-zwr";
import useFetcher from "@/utils/use-fetcher";

interface MobileValidationRequest {
  countryCode: string;
  mobileNumber: string;
}

interface MobileValidationResponse {
  valid: boolean;
}

export default function useMobileValidation() {
  const fetcher = useFetcher<
    MobileValidationRequest,
    MobileValidationResponse
  >();
  return useZWR<MobileValidationRequest, MobileValidationResponse>(
    {
      url: "/users/mobile/validation",
      method: "get",
    },
    fetcher
  );
}
